export function relativeURL(url) {
  const base = process.env.PUBLIC_URL || "";
  return base + url;
}
